import { CheckCircle2 } from "lucide-react";

interface IncludesGroup {
  title?: string;
  items: string[];
}

interface ServiceIncludesProps {
  eyebrow?: string;
  title?: string;
  description?: string;
  groups: IncludesGroup[];
}

const ServiceIncludes = ({
  eyebrow = "Qué incluye",
  title = "Exactamente lo que entregamos cada mes",
  description = "Sin letra pequeña. Estos son los entregables concretos del servicio.",
  groups,
}: ServiceIncludesProps) => {
  return (
    <section className="py-24">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-border bg-card text-xs uppercase tracking-widest text-muted-foreground font-body mb-6">
            {eyebrow}
          </div>
          <h2 className="font-display text-3xl md:text-5xl uppercase mb-4 leading-tight">
            {title}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">{description}</p>
        </div>

        <div className={`grid gap-6 ${groups.length > 1 ? "md:grid-cols-2" : "md:grid-cols-1 max-w-3xl mx-auto"}`}>
          {groups.map((group, idx) => (
            <div
              key={idx}
              className="rounded-2xl border border-border bg-card p-8 hover:border-primary/40 transition-colors"
            >
              {group.title && (
                <h3 className="text-xl font-semibold mb-6 pb-4 border-b border-border">
                  {group.title}
                </h3>
              )}
              <ul className="space-y-3">
                {group.items.map((item) => (
                  <li key={item} className="flex items-start gap-3 text-sm text-foreground/90">
                    <CheckCircle2
                      size={18}
                      className="text-primary shrink-0 mt-0.5"
                    />
                    <span className="leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceIncludes;
